import { useState, useEffect } from "react";
import { API } from "api";
import { UTILS } from "utils";
import { separateMediaUrlsByType } from "utils/Utils";

const useAllItems = () => {
  const [items, setItems] = useState([]);
  const [Itemloader, setLoading] = useState(true);
  const getItemsByBrand = async () => {
    const userDetail = UTILS.getCurrentUser();
    const result = await API.GET_ITEMS_BY_BRAND({
      token: userDetail.token,
      brandId: userDetail.brandId,
      language: "EN",
    });

    if (result && result?.success === 1) setItems(result?.data);
    else {
    }
    setLoading(false);
  };

  useEffect(() => {
    setLoading(true);
    getItemsByBrand();
    return () => {
      setItems([]);
    };
  }, []);

  return { items, Itemloader };
};


export const getCurrentUserTempUrl = async (params) => {
  try {
    const resp = await API.GET_CACHED_MEDIA_URLS({params:{
      ...(params ?? {}),
    }});
    return resp?.data?.mediaUrls
    
  } catch (error) {
    console.log({error});
  }finally{
  }
}
export const useCurrentUserTempUrl = ({params={}}= {})=>{
  const [urls, setUrls] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchTempUrls = async () => {
    setLoading(true);
    try {
      let urls = await getCurrentUserTempUrl(params)
      urls = separateMediaUrlsByType(urls, urls);
      setUrls(urls);
    } catch (error) {
      console.log({error});
    }finally{
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchTempUrls();
    return () => {
      setUrls([]);
    };
  }, []);

  return { urls, loading, setUrls, setLoading };
}

export default useAllItems;
